<script lang="ts">
  /**
   * The Helper install guide as a modal. Shown when no Helper is paired yet: replies
   * still queue and can still be drafted, they just won't send until the Helper is
   * running.
   */
  import HelperInstallSteps from './HelperInstallSteps.svelte';

  let { open, onClose }: { open: boolean; onClose: () => void } = $props();
</script>

{#if open}
  <div class="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4 sm:items-center">
    <button class="fixed inset-0 bg-black/55 backdrop-blur-[1px]" aria-label="Close" onclick={onClose}></button>

    <div class="relative z-10 my-4 w-full max-w-lg rounded-box border hair bg-base-100 shadow-2xl">
      <header class="flex items-start justify-between gap-3 border-b hair px-5 py-4">
        <div>
          <div class="eyebrow text-base-content/60">Sideguide Helper</div>
          <h2 class="mt-0.5 font-display text-lg font-semibold tracking-tight">Set up the Helper to send replies</h2>
        </div>
        <button class="btn btn-ghost btn-sm btn-square -mr-1.5" aria-label="Close" onclick={onClose}>
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
        </button>
      </header>

      <div class="max-h-[70vh] overflow-y-auto px-5 py-4">
        <p class="text-sm text-base-content/75">
          The Helper is a small Chrome extension that posts your queued replies to Skool from your own
          browser. Until it’s running, replies you write are saved to the queue — you just can’t send
          them yet. It takes about two minutes to set up.
        </p>

        <HelperInstallSteps />
      </div>

      <footer class="flex justify-end border-t hair px-5 py-3">
        <button class="btn btn-ghost btn-sm" onclick={onClose}>Done</button>
      </footer>
    </div>
  </div>
{/if}
